class NodeTypesIterator {
  public constructor(private collection: any[]) {
    this.current = 0;
  }

  private current;

  public next() {
    const item = this.collection[this.current];
    const hasNext = !!item;

    const result = { value: item, done: !hasNext };
    this.current += 1;

    return result;
  }
}

export class AllowedNodeTypesArray implements Iterable<string> {
  public constructor(allowedNodeTypes: string[]) {
    if (allowedNodeTypes) {
      this.allowedNodeTypes = Array.from(allowedNodeTypes);
      this.currentAllowedNodeTypes = Array.from(allowedNodeTypes);
      this.length = allowedNodeTypes.length;
    }

    return new Proxy(this, {
      get: (target, key) => {
        if (typeof key === 'string' && Number.isInteger(Number(key))) {
          return target.currentAllowedNodeTypes[key];
        } else {
          return target[key];
        }
      },
    });
  }

  public [Symbol.iterator](): Iterator<string, any, undefined> {
    return new NodeTypesIterator(this.currentAllowedNodeTypes);
  }

  private allowedNodeTypes: string[] = [];
  private currentAllowedNodeTypes: string[] = [];

  public length: number;

  public add(nodeType: string, isNewTypeBeingAdded = false) {
    if (
      !isNewTypeBeingAdded &&
      (this.currentAllowedNodeTypes.find(s => s === nodeType) || !this.allowedNodeTypes.find(s => s === nodeType))
    ) {
      return;
    }

    this.currentAllowedNodeTypes.push(nodeType);
    this.length = this.currentAllowedNodeTypes.length;
  }

  public remove(nodeType: string) {
    const found = this.currentAllowedNodeTypes.findIndex(s => s === nodeType);
    if (found !== -1) {
      this.currentAllowedNodeTypes.splice(found, 1);
    }
    this.length = this.currentAllowedNodeTypes.length;
  }

  public reset() {
    this.currentAllowedNodeTypes = this.allowedNodeTypes;
    this.length = this.currentAllowedNodeTypes.length;
  }

  public hasType(nodeType: string) {
    return !!this.currentAllowedNodeTypes.find(s => s === nodeType);
  }
}
